import CardGridSection from "@/components/common/CardGridSection";
import iconInsight from "@/assets/img/new/icon-insight.svg";
import iconBiometric from "@/assets/img/new/icon-biometric.svg";
import iconStreamline from "@/assets/img/new/icon-streamline.svg";
import NavbarFooter from "@/components/headtail/Navbar/NavbarFooter";


export default function LandingPage() {
  return (
    <div className="new-design">
      <div className="fp-container-fluid header__common header--index">
        <div className="mobile-content"></div>
        <div className="fp-container">
          <div className="fp-row">
            <div className="cell-12 cell-lg-6 header-content">
              <h1>Digital Trust and Interoperability</h1>
              <h2>Today, Tomorrow and the Future</h2>
              <div className="cta">
                <a href={"/contact-us"} className="primary">Request a Demo</a>
                <a href={"/contact-us"}>Learn More</a>
              </div>
              <b>Meet Further</b>
              <p>A Travel Technology company helping Airlines to enhance their Digital Passenger Control.</p>
              <p>With FURTHER, passenger journeys are seamless, document controls are safe, admissibility is instant,
                and crossing borders is at internet speed.</p>
            </div>
          </div>
        </div>
      </div>

      <section className="fp-container-fluid index__seamless">
        <div className="fp-container">
          <div className="fp-row mobile__bg"></div>
          <div className="fp-row">
            <div className="cell-12 cell-lg-6 index__seamless--content">
              <h2>Seamless Passenger Journey</h2>
              <p>It is the next level of passenger engagement!</p>
              <p>FURTHER shifts Airline's Know Your Customer capability. Instead of using online check-in to allocate
                seats and control travel documents at the airport, Airlines can experience off-airport onboarding by
                100% digital Identity and Travel Documents verification with FURTHER.</p>
              <p>See our detailed solutions;</p>
              <div className="solutions-list">
                <a href={"/solutions"} className="solution s1">Digital Passenger Identity</a>
                <a href={"/solutions"} className="solution s2">Admissibility</a>
                <a href={"/solutions"} className="solution s3">Onboarding</a>
                <a href={"/contact-us"} className="solution s4">Contact Us</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fp-container-fluid index__digital-onboarding">
        <div className="fp-container">
          <div className="fp-row">
            <div className="cell-lg-3 index__digital-onboarding--content">
              <h2>Digital Onboarding</h2>
              <p>Airlines have obligatory requirements to identify their passengers or customers. This identification
                process includes several document controls according to service type. FurtherPass digitalizes passenger
                identification and onboarding processes of airlines. FurtherPass enables airlines to identify their
                passengers and authenticate their travel-related documents.</p>
              <p>In a minute, ID and Biometric verification gives passengers the comfort of accessing different services
                as it enhances</p>
            </div>
          </div>
        </div>
        <div className="mask"></div>
      </section>

      <section className="fp-container-fluid index__blocks block-1">
        <div className="cell-lg-6 cell-12 block--image block-1-image"></div>
        <div className="cell-lg-4 cell-12 block--content block-1-content">
          <h2>
            Streamline Operations, Delight Passengers
          </h2>
          <p>FurtherPass empowers airlines with innovative solutions for seamless passenger experiences. Our platform
            optimizes check-in processes, reducing congestion, and enhancing efficiency. Discover how we can
            streamline your operations.</p>
          <div className="block-actions">
            <a href={"/contact-us"} className="primary">Request a Demo</a>
            <a href={"/contact-us"}>Learn More</a>
          </div>
        </div>
      </section>

      <section className="fp-container-fluid index__blocks block-2">
        <div className="cell-lg-6 cell-12 block--content block-2-content">
          <h2>
            Expand Your Horizons, Simplify Compliance
          </h2>
          <p>Navigating complex immigration requirements is now a breeze. FurtherPass simplifies document verification
            and admissibility checks, ensuring compliance and peace of mind for both airlines and passengers.
          </p>
          <div className="block-actions">
            <a href={"/contact-us"} className="primary">Request a Demo</a>
            <a href={"/contact-us"}>Learn More</a>
          </div>
        </div>
        <div className="cell-lg-6 cell-12 block--image block-2-image">
        </div>
      </section>

      <section className="fp-container-fluid index__blocks block-3">
        <div className="cell-lg-6 cell-12 block--image block-3-image">
        </div>
        <div className="cell-lg-4 cell-12 block--content block-3-content">
          <h2>
            Enhance Passenger Satisfaction, Boost Loyalty
          </h2>
          <p>
            Elevate the passenger journey to new heights. FurtherPass offers a seamless travel experience with
            biometric integration, delighting passengers and earning their loyalty
          </p>
          <div className="block-actions">
            <a href={"/contact-us"} className="primary">Request a Demo</a>
            <a href={"/contact-us"}>Learn More</a>
          </div>
        </div>
      </section>

      <CardGridSection
        sectionClass="index__navigating"
        topContent={
          <>
            <h2>Navigating the Transformative Winds of Passenger Preferences</h2>
            <p>
              In today's ever-evolving aviation landscape, it's imperative for airlines to heed the revelations
              unearthed by the 2022 IATA Global Passenger Survey. As we delve into these insights, a compelling
              narrative emerges, underscoring the pivotal role of digital transformation in reshaping the passenger
              experience. </p>
          </>
        }
        cards={[
          {
            icon: iconInsight,
            alt: "icon-insight",
            title: "Unveiling Key Passenger Insights",
            description: "Overcoming Deterrents: A significant 40% of travelers express hesitation in embarking on journeys, attributing their reluctance to immigration requirements. Within this group, a resounding 65% identify the complexity of these procedures as the primary deterrent. The message resonates clearly: simplification is the linchpin to instill passenger confidence.",
          },
          {
            icon: iconBiometric,
            alt: "icon-biometric",
            title: "Embracing Biometric Advancements",
            description: "The age of biometric identification has arrived, with an overwhelming 88% of passengers voicing their contentment with biometric processes. Notably, an impressive 75% of travelers are eager to embrace biometrics as a viable alternative to traditional passports and boarding passes, highlighting a burgeoning demand for streamlined, frictionless journeys.",
          },
          {
            icon: iconStreamline,
            alt: "icon-streamline",
            title: "Prioritizing Pre-Arrival Experiences",
            description: "The survey shines a spotlight on passengers' pre-arrival preferences, with 44% emphasizing the importance of streamlining the check-in process. Furthermore, 33% underscore the need for enhanced efficiency in immigration procedures, while 32% identify baggage check-in as a pivotal checkpoint to optimize before arriving at the airport.",
          },
        ]}
      />
      <div className="sub-menus index-navbar">
        <NavbarFooter/>
      </div>
    </div>
  );
}
